import React from "react";
import { motion } from "framer-motion";

const TechStack = ({ img, name }) => {
  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ rotate: 360, scale: 1 }}
      transition={{
        type: "spring",
        stiffness: 360,
        damping: 100,
        bounce:0.1
      }}
      className="py-2 px-4"
    >
      <div className="bg-black shadow-md border border-blue-500 shadow-blue-600 bg-opacity-50 space-y-1 h-28 w-28 rounded-lg flex flex-col justify-center items-center">
        <img className="h-16 w-16 rounded-full" src={img} alt="" />
        <motion.p
          initial={{ x: -100 }}
          animate={{ x: 0 }}
          transition={{
            delay: 1,
            duration:1
          }}
          className="text-blue-600"
        >{name}</motion.p>
      </div>
    </motion.div>
  );
};

export default TechStack;
